import gql from "graphql-tag";

export const CREATE_QUALIFICATIONS = gql`
  mutation AddQualification($data: QualificationDataInput) {
    addQualification(data: $data) {
      id
    }
  }
`;

const qualifications = { CREATE_QUALIFICATIONS };

export default qualifications;
